























import { computed, defineComponent, onBeforeUnmount, ref } from "@vue/composition-api";
import { TalentAgentSearchResult } from "@scrile/api-provider/dist/api/TalentAgentsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers, { getManagerProviders } from "@/lib/api";
import { setLoginData } from "@/lib/authHelper";
import BaseButton from "@/components/BaseButton";
import ModalSwitchAccount from "../ModalSwitchAccount";

export default defineComponent({
  name: "SwitchAccount",
  components: { BaseButton, ModalSwitchAccount },
  setup() {
    const { authUser, isTalentAgent } = useAuthUser();
    const showModalSwitchAccount = ref(false);
    const loadingUserId = ref("");
    const searchManagedCreators = ref<TalentAgentSearchResult | null>(null);
    const isManagerProviders = ref(false);
    const managerLongLiveToken = ref("");
    const managerId = ref(authUser.value?.id);

    const canManageUsers = computed(() => isTalentAgent.value || isManagerProviders.value);
    const managedCreators = computed(() => {
      const result: any[] = [];
      if (searchManagedCreators.value?.result.length) {
        result.push(searchManagedCreators.value.result[0].agent);
        searchManagedCreators.value.result.forEach(item => result.push(item.user));
      }
      return result;
    });

    let { providers: managerProviders, apiTools: managerApiTools } = getManagerProviders();
    const checkManagerProviders = async () => {
      managerLongLiveToken.value = await managerProviders.LoginProvider.getLongLiveToken();
      const longLiveToken = await providers.LoginProvider.getLongLiveToken();
      if (managerLongLiveToken.value) {
        managerId.value = (
          await managerProviders.LoginProvider.refreshTokenV2({ token: managerLongLiveToken.value })
        ).user.id;
      }
      if (!managerLongLiveToken.value) {
        managerLongLiveToken.value = longLiveToken;
        await managerProviders.LoginProvider.setLongLiveToken(longLiveToken);
      }

      if (managerLongLiveToken.value === longLiveToken) {
        managerApiTools.close();
        managerProviders = providers;
        isManagerProviders.value = false;
      } else {
        isManagerProviders.value = true;
      }
    };

    const handleSwapButtonClick = () => {
      showModalSwitchAccount.value = !showModalSwitchAccount.value;
    };

    const handleAccountClick = async (user: UserPublicData) => {
      if (loadingUserId.value === "") {
        try {
          loadingUserId.value = user.id;
          let token: string;
          if (user.id === searchManagedCreators.value?.result[0].agent?.id) {
            token = await managerProviders.LoginProvider.getLongLiveToken();
          } else {
            token = await managerProviders.LoginProvider.longLiveTokenByUser(user.id);
          }
          await providers.LoginProvider.setLongLiveToken(token);
          const loginResponse = await providers.LoginProvider.refreshTokenV2({ token });
          setLoginData({ user: loginResponse.user, authorities: loginResponse.authorities });
          location.reload();
        } finally {
          loadingUserId.value = "";
        }
      }
    };

    const getManagedCreators = async () => {
      await checkManagerProviders();
      if (canManageUsers.value) {
        searchManagedCreators.value = await managerProviders.TalentAgentsProvider.search({
          data: {
            agentId: managerId.value,
            size: 1000,
          },
        });
      }
      if (managerProviders !== providers && searchManagedCreators.value?.result.length === 0) {
        await managerProviders.LoginProvider.logout();
      }
    };

    const getData = async () => {
      await getManagedCreators();
    };

    getData();

    onBeforeUnmount(() => {
      if (managerProviders !== providers) {
        managerApiTools.close();
      }
    });

    return {
      authUser,
      canManageUsers,
      handleSwapButtonClick,
      isTalentAgent,
      showModalSwitchAccount,
      managedCreators,
      handleAccountClick,
      loadingUserId,
    };
  },
});
